import React, { useEffect, useMemo, useState } from 'react'

const KEY = 'a11y_hotkey_toast_shown_session'
const DURATION = 5000

function isMacOS() {
  if (typeof navigator === 'undefined') return false
  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform) ||
         /Mac OS X/i.test(navigator.userAgent)
}

const labels = {
  title: { ru: 'Специальные возможности', en: 'Accessibility', kz: 'Арнайы мүмкіндіктер' },
  line:  { ru: 'Открываются по', en: 'Open with', kz: 'Ашылады' },
  alt:   { ru: 'macOS — ⌘ + U', en: 'macOS — ⌘ + U', kz: 'macOS — ⌘ + U' }
}

function normalizeLang(raw) {
  const v = String(raw || '').toLowerCase()
  if (v.startsWith('en')) return 'en'
  if (v.startsWith('kk') || v.startsWith('kz')) return 'kz'
  return 'ru'
}

function getLang() {
  const a = localStorage.getItem('appLanguage')
  if (a) return normalizeLang(a)
  const b = localStorage.getItem('lang')
  if (b) return normalizeLang(b)
  return 'ru'
}

export default function A11yHotkeyToast() {
  const [visible, setVisible] = useState(false)
  const mac = useMemo(() => isMacOS(), [])
  const lang = getLang()

  useEffect(() => {
    try {
      if (sessionStorage.getItem(KEY) === '1') return
      sessionStorage.setItem(KEY, '1')
    } catch {
      // если sessionStorage недоступен — всё равно покажем
    }

    setVisible(true)
    const timer = setTimeout(() => setVisible(false), DURATION)
    return () => clearTimeout(timer)
  }, [])

  if (!visible) return null

  /* СВЕРХУ СЛЕВА */
  const style = {
    position: 'fixed',
    top: 16,
    left: 16,
    zIndex: 999999,
    background: '#111',
    color: '#fff',
    borderRadius: 12,
    padding: '14px 16px',
    maxWidth: 360,
    boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
    fontFamily: 'Inter, system-ui, Arial'
  }

  return (
    <div
      style={style}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      data-a11y-toast
    >
      <div style={{ fontWeight: 800, marginBottom: 6 }}>
        {labels.title[lang] || labels.title.ru}
      </div>

      <div style={{ fontSize: 13, opacity: 0.95 }}>
        {(labels.line[lang] || labels.line.ru) + ' '}
        <b>{mac ? '⌘ + U' : 'Ctrl + U'}</b>
      </div>

      <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
        {mac ? 'Windows — Ctrl + U' : (labels.alt[lang] || labels.alt.ru)}
      </div>
    </div>
  )
}
